/* Lentilla Laborator — storefront behaviour. No dependencies. */
(function () {
  "use strict";
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = window.dxMoney || "{{amount_with_comma_separator}} lei";
    var n = (cents / 100).toFixed(2);
    var parts = n.split(".");
    var dot = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ".");
    var comma = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return fmt.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, dot + "," + parts[1])
              .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/, dot)
              .replace(/\{\{\s*amount_no_decimals\s*\}\}/, comma)
              .replace(/\{\{\s*amount\s*\}\}/, comma + "." + parts[1])
              .replace(/RON/g, "lei");
  }
  window.dxMoneyFormat = money;

  /* ---------- toast ---------- */
  var toastT;
  function toast(msg, ms) {
    var t = $("#dxToast"); if (!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(toastT); toastT = setTimeout(function () { t.classList.remove("on"); }, ms || 2400);
  }
  window.dxToast = toast;

  /* ---------- cart ---------- */
  function paintCart(c) {
    $$("[data-fcart]").forEach(function (x) { x.toggleAttribute("data-empty", c.item_count === 0); });
    $$("[data-count]").forEach(function (x) { x.textContent = c.item_count; x.hidden = c.item_count === 0; });
    $$("[data-total]").forEach(function (x) { x.textContent = money(c.total_price); });
  }
  function refreshCart() { return fetch("/cart.js", { headers: { Accept: "application/json" } }).then(function (r) { return r.json(); }).then(function (c) { paintCart(c); return c; }); }
  function addItems(items, label) {
    return fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ items: items }) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () {
        if (/\/cart\/?$/.test(location.pathname)) { setTimeout(function () { location.reload(); }, 700); }
        return refreshCart().then(function (c) {
          var left = 25000 - c.total_price, msg = (label || "Produsul") + " a fost adăugat în coș";
          toast(msg + (left > 0 ? " · mai ai " + money(left) + " până la livrare gratuită" : " · ai livrare gratuită"), 3800);
          return c;
        });
      })
      .catch(function (e) { toast((e && (e.description || e.message)) || "Nu s-a putut adăuga în coș"); });
  }
  window.dxAdd = addItems;
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-add-id]");
    if (!b) return;
    e.preventDefault();
    var q = 1; var qs = b.getAttribute("data-qty-from"); if (qs && $(qs)) q = parseInt($(qs).value || $(qs).textContent, 10) || 1;
    var id = b.getAttribute("data-add-id"); var vsel = b.getAttribute("data-variant-from"); if (vsel && $(vsel)) id = $(vsel).value;
    b.disabled = true; addItems([{ id: parseInt(id, 10), quantity: q }], b.getAttribute("data-name")).then(function () { b.disabled = false; });
  });

  /* ---------- shipping cut-off (14:00, Bucharest, Mon–Fri) ---------- */
  function cutoff() {
    var parts = {};
    try { new Intl.DateTimeFormat("en-GB", { timeZone: "Europe/Bucharest", hour: "2-digit", minute: "2-digit", second: "2-digit", weekday: "short", hour12: false }).formatToParts(new Date()).forEach(function (p) { parts[p.type] = p.value; }); } catch (err) { return { open: false, txt: "" }; }
    var sec = (+parts.hour) * 3600 + (+parts.minute) * 60 + (+parts.second);
    var left = 14 * 3600 - sec, weekend = parts.weekday === "Sat" || parts.weekday === "Sun";
    if (weekend || left <= 0) return { open: false, txt: "" };
    var pad = function (n) { return String(n).padStart(2, "0"); };
    return { open: true, txt: pad(Math.floor(left / 3600)) + ":" + pad(Math.floor(left % 3600 / 60)) + ":" + pad(left % 60) };
  }
  function tick() {
    var c = cutoff();
    $$("[data-cutshort]").forEach(function (x) { x.textContent = c.open ? "comandă în " + c.txt + " și pleacă azi" : "expediere în 1 zi lucrătoare"; });
    $$("[data-shipline]").forEach(function (x) { x.textContent = c.open ? "Comandă în " + c.txt + " și pleacă azi." : "Comanda pleacă în următoarea zi lucrătoare."; });
  }
  tick(); setInterval(tick, 1000);

  /* ---------- header search (phone) ---------- */
  $$("[data-srch]").forEach(function (b) { b.addEventListener("click", function () { var h = b.closest(".hdr"); h.classList.toggle("srch-on"); var i = $(".msrch input", h); if (h.classList.contains("srch-on") && i) i.focus(); }); });

  /* ---------- product data for quiz / gauge ---------- */
  var P = {};
  $$("script[data-dx-products]").forEach(function (s) { try { var o = JSON.parse(s.textContent); for (var k in o) P[k] = o[k]; } catch (err) {} });
  function recCard(k, tag, why, alt) {
    var p = P[k]; if (!p) return "";
    var btn = p.av ? (p.one ? '<button class="btn k full" type="button" data-add-id="' + p.id + '" data-name="' + p.n + '">Adaugă ' + p.n + ' în coș</button>' : '<a class="btn k full" href="' + p.url + '">Alege varianta</a>') : '<a class="btn k full" href="' + p.url + '">Vezi produsul</a>';
    return '<div class="top"><a class="ph" href="' + p.url + '"><img class="mul" src="' + p.img + '" alt="' + p.n + '"></a><div><div class="tg">' + tag + '</div><div class="nm"><a href="' + p.url + '">' + p.n + '</a></div><div class="pr">' + p.p + (p.o ? '<s>' + p.o + '</s>' : '') + '</div></div></div><p>' + why + '</p>' + btn + (alt ? '<div class="alt">' + alt + '</div>' : '');
  }
  var L = function (k, txt) { return P[k] ? '<a href="' + P[k].url + '">' + (txt || P[k].n + ' · ' + P[k].p) + '</a>' : (txt || ""); };

  /* ---------- quiz ---------- */
  var quiz = $("[data-quiz]");
  if (quiz) {
    var st = { use: "night", rx: "no", who: "me", lvl: "light" };
    var draw = function () {
      $("#qWho", quiz).classList.toggle("off", st.use === "night");
      $("#qLvl", quiz).classList.toggle("off", !(st.use === "pc" && st.rx === "no" && st.who === "me"));
      var h;
      if (st.rx === "yes" && st.use !== "sun") h = recCard("orion", "RECOMANDAT · CLIP-ON", "Se prinde pe rama ochelarilor tăi de vedere, fără o pereche nouă cu dioptrii. Lentilele galbene fac lumina mai caldă la volan și filtrează o parte din lumina albastră a ecranelor.", "Îl scoți când nu ai nevoie de el – ochelarii tăi rămân la fel.");
      else if (st.rx === "yes") h = '<div class="tg">PENTRU SOARE, PESTE OCHELARII DE VEDERE</div><p>Momentan nu avem un clip-on polarizat de soare. Scrie-ne la trexmagazin@gmail.com și te anunțăm când apare.</p><div class="alt">Pentru seară și la volan merge clip-on-ul ' + L("orion") + '.</div>';
      else if (st.use === "night") h = recCard("heliom", "RECOMANDAT · CONDUS NOAPTEA", "Lentile galbene care fac lumina mai caldă și farurile mai puțin agresive. Merg și la calculator, cu filtru anti-blue light.", "Mai ușori și mai ieftini: " + L("light") + ". Formă aviator: " + L("xenoz") + ".");
      else if (st.use === "pc" && st.who === "kid") h = recCard("draco", "RECOMANDAT · PENTRU COPII", "Ramă mică, potrivită pentru fețele copiilor, cu lentile roșii și filtru anti-blue light pentru tabletă și telefon.", "Nu sunt recomandați pentru condus noaptea.");
      else if (st.use === "pc" && st.lvl === "strong") h = recCard("heliom", "RECOMANDAT · FILTRU PUTERNIC ~70%", "Lentile galbene care filtrează mai mult din lumina albastră – bune pentru serile lungi la ecran. Merg și la volan, noaptea.", "Culorile se văd mai calde. Pentru culori naturale toată ziua: " + L("zeus") + ".");
      else if (st.use === "pc") h = recCard("zeus", "RECOMANDAT · FILTRU UȘOR ~20%", "Lentile clare cu filtru de lumină albastră – culorile rămân naturale, îi porți toată ziua la birou.", "Vrei filtru mai puternic, pentru seară? " + L("heliom", "HELIOM · ~70%") + ".");
      else if (st.who === "kid") h = recCard("draco", "RECOMANDAT · PENTRU COPII", "Ramă mică, protecție UV400 – potrivită pentru fețele copiilor.", "Lentilele sunt roșii, cu filtru anti-blue light.");
      else h = '<div class="tg">RECOMANDAT · LA SOARE</div><div class="nm">Ochelari de soare polarizați</div><p>Lentilele polarizate UV400 taie reflexiile de pe asfalt, apă și parbriz. Alege culoarea care îți place:</p><div class="sunrow">' +
        ["obsidian", "royal", "lava", "fire"].filter(function (k) { return P[k]; }).map(function (k) { return '<a href="' + P[k].url + '"><img class="mul" src="' + P[k].img + '" alt="' + P[k].n + '"><b>' + P[k].n + '</b><span>' + P[k].p + '</span></a>'; }).join("") +
        '</div><a class="btn k full" href="/collections/ochelari-de-soare">Vezi toți ochelarii de soare</a>';
      $("#res2", quiz).innerHTML = h;
      var bb = $("#blueBand"); if (bb) bb.style.opacity = st.use === "sun" ? ".25" : "1";
    };
    $$("[data-q]", quiz).forEach(function (g) { $$("button", g).forEach(function (b) { b.addEventListener("click", function () { $$("button", g).forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); st[g.getAttribute("data-q")] = b.getAttribute("data-v"); draw(); }); }); });
    draw();
  }

  /* ---------- screen-hours gauge ---------- */
  var gauge = $("[data-hours]");
  if (gauge) {
    var r = $("#hr2", gauge), v = $("#hrv2", gauge), z = $("#zone2", gauge), out = $("#rec2", gauge);
    var drawH = function () {
      var h = +r.value, k, t, zn, i; v.textContent = h;
      if (h <= 4) { k = "zeus"; zn = "PUȚIN"; i = 1; t = "Până la 4 ore pe zi: lentile clare cu filtru ușor (~20%), culori naturale."; }
      else if (h <= 9) { k = "heliom"; zn = "ZI DE LUCRU"; i = 2; t = "Peste 4 ore pe zi: lentilele galbene filtrează mai mult din lumina albastră (~70%). Nu uita de pauzele 20-20-20."; }
      else { k = "heliom"; zn = "MULT"; i = 3; t = "Peste 10 ore, mai ales seara: lentilele galbene filtrează ~70% și merg și la volan, noaptea."; }
      z.textContent = zn; ["z1", "z2", "z3"].forEach(function (id, n) { $("#" + id, gauge).classList.toggle("on", n < i); });
      out.innerHTML = recCard(k, "RECOMANDAT PENTRU " + h + " " + (h === 1 ? "ORĂ" : "ORE"), t);
    };
    r.addEventListener("input", drawH); drawH();
  }

  /* ---------- collection filters + sort (client side, the catalog is small) ---------- */
  var cat = $("[data-catalog]");
  if (cat) {
    var grid = $("#catGrid", cat), cards = $$("[data-card]", grid), cnt = $("#cnt", cat);
    var cst = { use: (new URLSearchParams(location.search)).get("f") || "all", lens: [], sort: "rec" };
    var T = { all: ["Toți ochelarii", ""], night: ["Ochelari pentru condus noaptea", "Lentile galbene care cresc contrastul și îmblânzesc farurile din sens opus."], pc: ["Ochelari pentru calculator", "Filtru anti-blue light pentru birou, gaming și seri lungi pe telefon."], sun: ["Ochelari de soare", "Polarizați UV400 pentru condus și plajă, plus lentile oglindă."], clip: ["Clip-on pentru ochelari de vedere", "Se prinde pe rama ta și o transformă în ochelari pentru condus noaptea sau ecran."], sale: ["Oferte", "Modelele cu preț redus."] };
    var drawC = function () {
      var shown = cards.filter(function (c) {
        var u = (c.getAttribute("data-use") || "").split(",");
        var ok = cst.use === "all" || (cst.use === "sale" ? c.getAttribute("data-sale") === "1" : u.indexOf(cst.use) >= 0);
        if (ok && cst.lens.length) ok = cst.lens.indexOf(c.getAttribute("data-lens")) >= 0;
        c.hidden = !ok; return ok;
      });
      var key = function (c) { return cst.sort === "asc" || cst.sort === "desc" ? +c.getAttribute("data-price") : cst.sort === "rev" ? -(+c.getAttribute("data-rc")) : +c.getAttribute("data-i"); };
      shown.sort(function (a, b) { return cst.sort === "desc" ? key(b) - key(a) : key(a) - key(b); }).forEach(function (c) { grid.appendChild(c); });
      cnt.textContent = shown.length + (shown.length === 1 ? " MODEL" : " MODELE");
      $("#catEmpty", cat).hidden = shown.length > 0;
      $$("[data-fv]", cat).forEach(function (b) { b.setAttribute("aria-pressed", b.getAttribute("data-fv") === cst.use); });
      $$("input[name=useF]", cat).forEach(function (i) { i.checked = i.value === cst.use; });
      if (cat.hasAttribute("data-retitle") && T[cst.use] && cst.use !== "all") { var t = $("#catTitle"); if (t) t.textContent = T[cst.use][0]; var l = $("#catLead"); if (l && T[cst.use][1]) l.textContent = T[cst.use][1]; }
    };
    cards.forEach(function (c, i) { c.setAttribute("data-i", i); });
    $$("[data-fv]", cat).forEach(function (b) { b.addEventListener("click", function () { cst.use = b.getAttribute("data-fv"); drawC(); }); });
    $$("input[name=useF]", cat).forEach(function (i) { i.addEventListener("change", function () { cst.use = i.value; drawC(); }); });
    $$("input[name=lensF]", cat).forEach(function (i) { i.addEventListener("change", function () { cst.lens = $$("input[name=lensF]:checked", cat).map(function (x) { return x.value; }); drawC(); }); });
    var so = $("#sort", cat); if (so) so.addEventListener("change", function () { cst.sort = so.value; drawC(); });
    drawC();
  }

  /* ---------- product page ---------- */
  var pdp = $("[data-pdp]");
  if (pdp) {
    $$("[data-img]", pdp).forEach(function (b) { b.addEventListener("click", function () { var m = $("#gmain", pdp); m.src = b.getAttribute("data-img"); m.removeAttribute("srcset"); $$("[data-img]", pdp).forEach(function (x) { x.setAttribute("aria-pressed", x === b); }); }); });
    var q = $("#pq", pdp);
    $$("[data-qd]", pdp).forEach(function (b) { b.addEventListener("click", function () { q.value = Math.max(1, (parseInt(q.value, 10) || 1) + (+b.getAttribute("data-qd"))); }); });
    var vs = $("#pvar", pdp);
    var pick = function (btn) {
      $$("[data-var]", pdp).forEach(function (x) { x.setAttribute("aria-pressed", x === btn); });
      var vi = btn.getAttribute("data-vimg"); if (vi) { var gm = $("#gmain", pdp); if (gm) { gm.src = vi; gm.removeAttribute("srcset"); } $$("[data-img]", pdp).forEach(function (x) { x.setAttribute("aria-pressed", x.getAttribute("data-img") === vi); }); }
      vs.value = btn.getAttribute("data-var");
      var pb = $("#pprice", pdp); if (pb) pb.textContent = btn.getAttribute("data-price");
      var add = $("#pAdd", pdp), av = btn.getAttribute("data-av") === "1";
      if (add) { add.disabled = !av; add.textContent = av ? "Adaugă în coș" : "Stoc epuizat"; }
    };
    $$("[data-var]", pdp).forEach(function (b) { b.addEventListener("click", function () { pick(b); }); });
    var fbTot = $("#fbTot", pdp);
    var fb = function () { var t = 0; $$("[data-fb]", pdp).forEach(function (i) { if (i.checked) t += +i.getAttribute("data-cents"); }); if (fbTot) fbTot.textContent = money(t); };
    $$("[data-fb]", pdp).forEach(function (i) { i.addEventListener("change", fb); }); fb();
    var fbAdd = $("#fbAdd", pdp);
    if (fbAdd) fbAdd.addEventListener("click", function () {
      var items = $$("[data-fb]", pdp).filter(function (i) { return i.checked; }).map(function (i) { return { id: +i.getAttribute("data-fb"), quantity: 1 }; });
      addItems(items, items.length + " produse");
    });
    /* sticky bar on phones once the main button scrolls away */
    var sticky = $(".sticky"), main = $("#pAdd", pdp);
    if (sticky && main && "IntersectionObserver" in window) {
      new IntersectionObserver(function (en) { sticky.classList.toggle("show", !en[0].isIntersecting && en[0].boundingClientRect.top < 0); }).observe(main);
    }
  }

  /* ---------- cart page ---------- */
  $$("[data-line]").forEach(function (b) {
    b.addEventListener("click", function () {
      var line = +b.getAttribute("data-line"), qn = +b.getAttribute("data-q");
      b.disabled = true;
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ line: line, quantity: qn }) })
        .then(function () { location.reload(); });
    });
  });

  /* ---------- favourites (stored on this device) ---------- */
  var FKEY = "dx-favs";
  function favs() { try { return JSON.parse(localStorage.getItem(FKEY) || "[]"); } catch (err) { return []; } }
  function setFavs(a) { try { localStorage.setItem(FKEY, JSON.stringify(a)); } catch (err) {} }
  $$("[data-fav]").forEach(function (b) {
    var h = b.getAttribute("data-fav"), on = favs().indexOf(h) >= 0;
    b.setAttribute("aria-pressed", on);
    b.addEventListener("click", function (e) {
      e.preventDefault(); var a = favs(), i = a.indexOf(h);
      if (i >= 0) { a.splice(i, 1); toast("Scos din favorite"); } else { a.push(h); toast("Adăugat la favorite"); }
      setFavs(a); b.setAttribute("aria-pressed", i < 0);
    });
  });
  $$("[data-fav-count]").forEach(function (x) { x.textContent = favs().length; });
  var favBox = $("[data-fav-list]");
  if (favBox) {
    var list = favs();
    if (!list.length) favBox.innerHTML = '<p class="muted">Nu ai produse la favorite. Apasă inima de pe pagina unui produs ca să-l salvezi aici.</p>';
    else Promise.all(list.map(function (h) { return fetch("/products/" + h + ".js").then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; }); })).then(function (ps) {
      favBox.innerHTML = ps.filter(Boolean).map(function (p) {
        return '<div class="favi"><a class="ph" href="' + p.url + '"><img class="mul" src="' + (p.featured_image ? p.featured_image + "&width=200" : "") + '" alt=""></a><div><a href="' + p.url + '"><b>' + p.title + '</b></a><span>' + money(p.price) + '</span></div>' +
          (p.available ? '<button class="btn k" type="button" data-add-id="' + p.variants[0].id + '" data-name="' + p.title.replace(/"/g, "") + '">Adaugă</button>' : '<span class="muted">Stoc epuizat</span>') + '</div>';
      }).join("");
    });
  }

  /* ---------- account tabs ---------- */
  var acc = $("[data-account]");
  if (acc) {
    var show = function (id) {
      $$("[data-pane]", acc).forEach(function (p) { p.hidden = p.getAttribute("data-pane") !== id; });
      $$("[data-tab]", acc).forEach(function (t) { t.setAttribute("aria-current", t.getAttribute("data-tab") === id ? "page" : "false"); });
    };
    $$("[data-tab]", acc).forEach(function (t) { t.addEventListener("click", function (e) { e.preventDefault(); show(t.getAttribute("data-tab")); history.replaceState(null, "", "#" + t.getAttribute("data-tab")); }); });
    var start = (location.hash || "#sumar").slice(1); if (!$('[data-pane="' + start + '"]', acc)) start = "sumar"; show(start);
    $$("[data-goto]", acc).forEach(function (a) { a.addEventListener("click", function (e) { e.preventDefault(); show(a.getAttribute("data-goto")); }); });
  }
  // Product reviews: drawn by us from the data Opinew embeds in the page (page 1) and its public API (next pages).
  // The Opinew widget renders lazily and unreliably, so it stays hidden and only opens for writing a review.
  (function () {
    var ph = document.querySelector("[data-rev-ph]"), src = document.getElementById("opinew-plugin");
    if (!ph || !src) return;
    var data; try { data = JSON.parse(src.getAttribute("data-opw-prodreviews")); } catch (e) { return; }
    var first = (data.reviews && (data.reviews.recent || data.reviews)) || [];
    if (!first.length || !data.product) return;
    document.body.classList.add("rv-own");
    var pid = data.product.platform_product_id, pages = data.review_page_count || 1, page = 1;
    var count = data.product.review_number || first.length, avg = Number(data.product.average_stars || 5);
    var esc = function (t) { return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    var stars = function (n) { n = Math.max(0, Math.min(5, Math.round(n))); return "★★★★★".slice(0, n) + "<span>" + "★★★★★".slice(n) + "</span>"; };
    var imgs = function (r) { var t = r.image_urls_optimised || r.image_urls || [], o = r.image_urls || t; return t.map(function (u, i) { return { t: u, f: o[i] || u }; }); };
    var card = function (r) {
      var name = (r.user_name || "Client").trim(), d = (r.created_ts || "").slice(0, 10).split("-").reverse().join(".");
      var im = imgs(r).slice(0, 3).map(function (u) { return '<img src="' + esc(u.t) + '" data-full="' + esc(u.f) + '" alt="Poză de la ' + esc(name) + '" loading="lazy">'; }).join("");
      return '<article class="rv"><header><span class="rv-av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + "</span><span><b>" + esc(name) + "</b>" +
        (r.verified_review ? "<small>✓ Achiziție verificată</small>" : "") + "</span></header>" +
        '<div class="rv-meta"><span class="rv-st" aria-label="' + r.star_rating + ' din 5 stele">' + stars(r.star_rating || 5) + "</span><time>" + esc(d) + "</time></div>" +
        "<p>" + esc(r.body) + "</p>" + (im ? '<div class="rv-im">' + im + "</div>" : "") + "</article>";
    };
    var sec = ph.parentNode;
    var head = document.createElement("div"); head.className = "rv-head";
    head.innerHTML = '<div class="rv-score"><b>' + avg.toFixed(1) + '</b><div><span class="rv-st">' + stars(avg) + "</span><small>" + count + (count === 1 ? " recenzie" : " recenzii") + "</small></div></div>";
    var write = document.createElement("button"); write.type = "button"; write.className = "btn l"; write.textContent = "Scrie o recenzie";
    head.appendChild(write); sec.appendChild(head);
    var pics = [];
    first.forEach(function (r) { imgs(r).forEach(function (u) { if (pics.length < 8) pics.push(u); }); });
    if (pics.length) {
      var ps = document.createElement("div"); ps.className = "rv-pics";
      ps.innerHTML = "<b>Poze de la clienți</b><div>" + pics.map(function (u) { return '<img src="' + esc(u.t) + '" data-full="' + esc(u.f) + '" alt="Poză de la client" loading="lazy">'; }).join("") + "</div>";
      sec.appendChild(ps);
    }
    var list = document.createElement("div"); list.className = "rv-fb"; sec.appendChild(list);
    var foot = document.createElement("div"); foot.className = "rv-foot";
    var more = document.createElement("button"); more.type = "button"; more.className = "btn l"; more.textContent = "Mai multe recenzii";
    foot.appendChild(more); sec.appendChild(foot);
    var clamp = function () {
      $$(".rv p", list).forEach(function (p) {
        if (p.dataset.c || p.scrollHeight <= p.clientHeight + 2) return;
        p.dataset.c = "1";
        var b = document.createElement("button"); b.type = "button"; b.className = "rv-more"; b.textContent = "Citește tot";
        b.addEventListener("click", function () { var open = p.classList.toggle("open"); b.textContent = open ? "Mai puțin" : "Citește tot"; });
        p.after(b);
      });
    };
    var add = function (rows) { var t = document.createElement("div"); t.innerHTML = rows.map(card).join(""); while (t.firstChild) list.appendChild(t.firstChild); clamp(); };
    add(first);
    more.hidden = pages <= 1;
    more.addEventListener("click", function () {
      more.disabled = true; more.textContent = "Se încarcă…";
      fetch("https://api.opinew.com/plugins/product_api?get_by=platform_product_id&platform_product_id=" + encodeURIComponent(pid) + "&sort_by=recent&page=" + (page + 1))
        .then(function (r) { return r.json(); })
        .then(function (d) {
          var rows = (d.reviews && (d.reviews.recent || d.reviews)) || [];
          page++; add(rows);
          more.hidden = page >= pages || !rows.length;
        })
        .catch(function () { toast("Nu am putut încărca mai multe recenzii"); })
        .then(function () { more.disabled = false; more.textContent = "Mai multe recenzii"; });
    });
    write.addEventListener("click", function () {
      document.body.classList.add("rv-write");
      var w = document.getElementById("opinew-reviews-product-page-code");
      if (w) w.scrollIntoView({ behavior: "smooth", block: "start" });
    });
  })();
  // Copy buttons (affiliate code / link)
  document.addEventListener("click", function (e) {
    var b = e.target.closest("[data-copy]"); if (!b) return;
    var txt = b.getAttribute("data-copy"), done = function () { toast("Copiat: " + txt); };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(txt).then(done, function () { window.prompt("Copiază:", txt); });
    else window.prompt("Copiază:", txt);
  });
  // Homepage: latest reviews of the featured product, from Opinew's public API.
  (function () {
    var box = document.querySelector("[data-hrv]"); if (!box) return;
    var list = box.querySelector("[data-hrv-list]"), url = box.getAttribute("data-url");
    var esc = function (t) { return String(t == null ? "" : t).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); };
    fetch("https://api.opinew.com/plugins/product_api?get_by=platform_product_id&platform_product_id=" + box.getAttribute("data-hrv") + "&sort_by=recent&page=1")
      .then(function (r) { return r.json(); })
      .then(function (d) {
        var rows = ((d.reviews && (d.reviews.recent || d.reviews)) || []).slice(0, 3);
        if (!rows.length) return;
        list.innerHTML = rows.map(function (r) {
          var name = (r.user_name || "Client").trim(), s = Math.max(1, Math.min(5, r.star_rating || 5));
          var t = r.image_urls_optimised || r.image_urls || [], o = r.image_urls || t;
          var im = t.length ? '<div class="rv-im">' + t.map(function (u, i) { return '<img src="' + esc(u) + '" data-full="' + esc(o[i] || u) + '" alt="Poză de la ' + esc(name) + '" loading="lazy">'; }).join("") + (t.length > 1 ? "<span>+" + (t.length - 1) + "</span>" : "") + "</div>" : "";
          return '<article class="hrv-card"><header><span class="rv-av" aria-hidden="true">' + esc(name.charAt(0).toUpperCase()) + "</span><span><b>" + esc(name) + "</b>" +
            (r.verified_review ? "<small>✓ Achiziție verificată</small>" : "") + '</span></header><span class="rv-st">' + "★★★★★".slice(0, s) + "</span>" +
            "<p>" + esc(r.body) + "</p>" + im + '<a href="' + esc(url) + '#recenzii">Citește recenzia →</a></article>';
        }).join("");
      })
      .catch(function () {});
  })();

  // Lightbox for customer photos in reviews.
  (function () {
    var lb = null, group = [], at = 0;
    var show = function () { lb.querySelector("img").src = group[at]; lb.querySelector("[data-n]").textContent = group.length > 1 ? (at + 1) + " / " + group.length : ""; lb.classList.toggle("multi", group.length > 1); };
    var close = function () { if (lb) { lb.hidden = true; document.documentElement.style.overflow = ""; } };
    var build = function () {
      lb = document.createElement("div"); lb.className = "lbx"; lb.hidden = true;
      lb.innerHTML = '<button type="button" class="lbx-x" aria-label="Închide">×</button><button type="button" class="lbx-p" aria-label="Poza anterioară">‹</button><img alt="Poză de la client"><button type="button" class="lbx-n" aria-label="Poza următoare">›</button><span data-n></span>';
      document.body.appendChild(lb);
      lb.addEventListener("click", function (e) {
        if (e.target.closest(".lbx-p")) { at = (at - 1 + group.length) % group.length; show(); }
        else if (e.target.closest(".lbx-n")) { at = (at + 1) % group.length; show(); }
        else if (!e.target.closest("img")) close();
      });
      document.addEventListener("keydown", function (e) {
        if (!lb || lb.hidden) return;
        if (e.key === "Escape") close();
        if (e.key === "ArrowLeft" && group.length > 1) { at = (at - 1 + group.length) % group.length; show(); }
        if (e.key === "ArrowRight" && group.length > 1) { at = (at + 1) % group.length; show(); }
      });
    };
    document.addEventListener("click", function (e) {
      var img = e.target.closest(".rv-im img, .rv-pics img"); if (!img) return;
      e.preventDefault();
      var scope = img.closest(".rv-im, .rv-pics");
      group = $$("img", scope).map(function (i) { return i.getAttribute("data-full") || i.src; });
      at = Math.max(0, $$("img", scope).indexOf(img));
      if (!lb) build();
      lb.hidden = false; document.documentElement.style.overflow = "hidden"; show();
    });
  })();
  // Bundles hero: automatic crossfade slideshow (pauses on hover / when the tab is hidden).
  $$("[data-slides]").forEach(function (box) {
    var sl = $$(".bh-sl", box), dots = $$(".bh-dots button", box), i = 0, t = null;
    if (sl.length < 2) return;
    var go = function (n) { sl[i].classList.remove("on"); if (dots[i]) dots[i].removeAttribute("aria-current"); i = (n + sl.length) % sl.length; sl[i].classList.add("on"); if (dots[i]) dots[i].setAttribute("aria-current", "true"); };
    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var play = function () { stop(); if (!reduce) t = setInterval(function () { if (!document.hidden) go(i + 1); }, 3500); };
    var stop = function () { if (t) clearInterval(t); t = null; };
    dots.forEach(function (d, n) { d.addEventListener("click", function () { go(n); play(); }); });
    box.addEventListener("mouseenter", stop); box.addEventListener("mouseleave", play);
    play();
  });
  // Desktop: floating cart follows the page once the header is scrolled away (only when the cart has items).
  (function () {
    var f = $("[data-fcart]"); if (!f) return;
    var on = function () { f.classList.toggle("on", window.scrollY > 160); };
    window.addEventListener("scroll", on, { passive: true }); on();
  })();
})();
